export default {
      path: '/lvy-mbti',
      component: () => import('./LVYMbti.vue'),
      meta: {
        title: '性格测试',
        designWidth: 750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (中国标准时间)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      },
      children: [
        {
          path: 'guide',
          name: 'Guide',
          component: () => import('./guide.vue'),
          meta: {
            title: '性格测试',
            designWidth: 750,
          }
        },
        {
          path: 'question',
          name: 'Question',
          component: () => import('./question.vue'),
          meta: {
            title: '性格测试题目',
            designWidth: 750,
          }
        },
        {
          path: 'result',
          name: 'Result',
          component: () => import('./result.vue'),
          meta: {
            title: '性格测试结果',
            designWidth: 750,
          },
        },
      ]
    }